import { render, staticRenderFns } from "./left-side.vue?vue&type=template&id=7bc3d0d4&"
import script from "./left-side.vue?vue&type=script&lang=js&"
export * from "./left-side.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports